import { Component, Input, OnInit } from '@angular/core';
import * as fromShared from '../../../shared';
import * as fromInvoiceSetup from '../../../data-services/invoice/setup';
import * as fromDataServices from '../../../data-services';
import { ReplaySubject } from 'rxjs';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-address',
    templateUrl: './invoice-address.component.html',
    styleUrls: ['./invoice-address.component.scss'],
    standalone: false
})
export class InvoiceAddressComponent
    extends fromShared.EditGrid<fromDataServices.Address.Address>
    implements OnInit {
    @Input() states: SelectItem[] = [];
    @Input() addressTypes: SelectItem[] = [];
    numCols = 14;
    addAddressReplaySubject = new ReplaySubject<boolean>(1);
    editItemSubject = new ReplaySubject<fromDataServices.Address.Address>(1);
    constructor(private log: LoggingService) {
        super();
    }
    ngOnInit(): void {}
    onCancelAddress() {
        this.addAddressReplaySubject.next(false);
        this.editItemSubject.next({
            id: -1,
            Addressid: -1
        } as fromDataServices.Address.Address);
    }
    onSaveAddress(item: fromDataServices.Address.Address) {
        this.log.verbose({
            type: 'InvoiceAddressComponent:onSaveAddress',
            item
        });
        this.SaveItem.next([item]);
        this.addAddressReplaySubject.next(false);
        this.editItemSubject.next({
            id: -1,
            Addressid: -1
        } as fromDataServices.Address.Address);
    }
    onEditItem(item: fromDataServices.Address.Address) {
        this.log.verbose({
            type: 'InvoiceAddressComponent:onEditItem',
            item
        });
        this.editItemSubject.next(item);
        this.addAddressReplaySubject.next(true);
    }
}
